import { render, staticRenderFns } from "./concierge-item.html?vue&type=template&id=40f5a99d&scoped=true&"
import script from "./concierge-item.js?vue&type=script&lang=js&"
export * from "./concierge-item.js?vue&type=script&lang=js&"
import style0 from "./concierge-item.scss?vue&type=style&index=0&id=40f5a99d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f5a99d",
  null
  
)

export default component.exports